import { useQueryClient } from '@tanstack/react-query';
import { Column, Typography, useOverlayContext } from 'seagull';
import { QueryKeys } from "../../../hooks/reactQuery/queryKeys";
import { useMutationState } from "../../../hooks/reactQuery/useMutationState";
import { useStoreActions } from "../../../store/store-context";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export const useDeleteLegalTerms = _ref => {
  let {
    onSuccess: _onSuccess,
    confirmActionTestId
  } = _ref;
  const {
    api
  } = useStoreActions();
  const queryClient = useQueryClient();
  const {
    showConfirmAction
  } = useOverlayContext();
  const {
    mutateAsync: deleteLegalTerms,
    isPending
  } = useMutationState({
    mutationFn: async legalTermsId => {
      await api.business.removeLegalTerms(legalTermsId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.LegalTerms]
      });
      _onSuccess();
    }
  });
  const onDeleteLegalTerm = data => {
    showConfirmAction({
      testid: confirmActionTestId,
      skin: 'danger',
      title: 'Delete document?',
      content: /*#__PURE__*/_jsxs(Column, {
        gap: 22,
        children: [/*#__PURE__*/_jsxs(Typography, {
          children: ["The document \u201C", data.name, "\u201D (", data.name, ".pdf) will be permanently deleted from your Terms of Service list."]
        }), /*#__PURE__*/_jsx(Typography, {
          children: "Existing agreements will not be affected."
        })]
      }),
      primaryButtonLabel: 'Delete',
      secondaryButtonLabel: 'Cancel',
      onConfirm: async () => void deleteLegalTerms(data.id)
    });
  };
  return {
    deleteLegalTerms: onDeleteLegalTerm,
    isPending
  };
};